/**
 * Created by udaltsov_av on 13.04.17.
 */
let modules = require('../../core/modules.json');

/**
 * Импорт css из набора openLayers
 */
require('../../../node_modules/openlayers/css/ol.css');

function getFunctionModule(modules, name) {
  for (let item in modules[name]) {
    if (item === "functions") return true;
  }
  return false
}

let api = {};

getModules(modules, api, "modules");

function getModules(modules, apiObject, name) {
  let func = getFunctionModule(modules, name);
  apiObject[name] = {};
  if (func) {
    for (let i = 0; i < modules[name].functions.length; i++) {
      let moduleName = modules[name].functions[i].name;
      let pathModule = modules[name].functions[i].path;
      apiObject[name][moduleName] = require("../../modules" + pathModule);
    }
  }
  for (let item in modules[name]) {
    if (item !== "functions") {
      getModules(modules[name], apiObject[name], item)
    }
  }
}

api = api.modules;
export {api}